import {
  BULKADDREMOVETOOL_EDIT,
  BULKADDREMOVETOOL_START_DRAGGING,
  BULKADDREMOVETOOL_END_DRAGGING,
  BULKADDREMOVETOOL_UPDATE_DEIMENSIONS
} from "../lib/types";

const initialState = {
  active: false,
  dragging: false,
  originX: 0,
  originY: 0,
  height: 0,
  width: 0
};

export default (state = initialState, action) => {
  /* discriminate the action type */
  switch (action.type) {
    case BULKADDREMOVETOOL_START_DRAGGING:
      return {
        ...state,
        originX: action.payload.x,
        originY: action.payload.y,
        width: 0,
        height: 0,
        dragging: true
      };
    case BULKADDREMOVETOOL_UPDATE_DEIMENSIONS:
      return {
        ...state,
        width: action.payload.width,
        height: action.payload.height
      };
    case BULKADDREMOVETOOL_END_DRAGGING:
      return {
        ...state,
        width: action.payload.width,
        height: action.payload.height,
        dragging: action.payload.dragging
      };
    case BULKADDREMOVETOOL_EDIT:
      return {
        ...state,
        originX: 0,
        originY: 0,
        width: 0,
        height: 0,
        active: action.payload
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/bulkaddremovetool-reducer.js